
<template>
    <div>
        <b-table class="table-responsive-lg"    striped  :items="files" :fields="fields">
            <template  v-slot:head(link)="data">
                <span class="fs-xl text-center" v-html="data.label"></span>
            </template>
            
            <template  v-slot:cell(link)="data" >
                <span class="get_file cursor-pointer" @click="get_file(data.item)">
                     <i class="fal  fa-save save_me"></i>
                </span>
            </template>
        </b-table>
    </div>
</template>

<script >

export default {
    name: "internal_files",
    components: {},
    
    props : {
        files : {
            type : Array
        }
    },
    
    data() {
        return {
            
            fields: [
              /*  {
                    key: 'id',
                    label: 'ID',
                    sortable: true
                },*/
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
               /* {
                    key: 'user_small',
                    label: 'ПIБ',
                    sortable: true
                },*/
                {
                    key: 'added',
                    label: 'Дата',
                    sortable: true
                },
                {
                    key : 'link',
                    label: '<i class="fal fa-save"></i>',
                    sortable: false
                },
            
            ],
            cur_right : '',
        }
    },
    
    created() {
    
    },
    
    methods: {
        get_file(item) {
           IMC_CORE.showloading();
            
            api.get('/files/' + item.id, { responseType: 'blob' }) // responseType важен!
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', item.name); // Имя файла
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        document.body.removeChild(fileLink);
                    } else {
                        EventBus.$emit('show_toast', { err: 'File not found', type: "danger", title: 'Error' });
                    }
                })
                .catch(err => {
                    EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
                })
                .finally(() => {
                    IMC_CORE.hideloading();
                });
        },
    }
}
</script>


<style scoped>

</style>